import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Text, RichText } from "./base/index";
import { PageStateContext } from "../PageContext";

const GlossaryTerm = ({ termId }) => {
  const { pageState } = useContext(PageStateContext);
  const { glossary } = pageState;
  const term = glossary.find(item => item.id === termId);
  if (!term) {
    return null;
  }

  return (
    <div className="ml-2 pl-6 border-l-2 border-blue-accent my-3 pt-1 break-inside-avoid">
      <Text tag="label" className="mb-2 -ml-2">
        *{term.title}
      </Text>
      <RichText html={term.definition} variant="sm" />
    </div>
  );
};

GlossaryTerm.propTypes = {
  termId: PropTypes.string.isRequired,
};

export default GlossaryTerm;
